<template>
    <div>
        <div class="form-group required" :class="{'has-error': errors.has(nomChamp)}">
            <label :for="nomChamp" class="form-label">{{ lblRevenu }}</label>
            <div class="input-group">
                <div class="input-group-addon">{{monnaie}}</div>
                    <input type="text"
                           v-validate="withValidation"
                           :name="nomChamp"
                           :id="nomChamp"
                           @input="onInput($event.target)"
                           v-on:blur="formatMoney($event);onBlur($event.target)"
                           @focus="onFocus"
                           v-tooltip="{content: getTooltipAvecOptions(tooltipTitre, tooltipContenu, null, optionsContenu), placement: tooltipPlacement }"
                           data-vv-as="revenu"
                           :maxlength="maxLength"
                           class="form-control">
            </div>
            <span v-if="submitted && errors.has(nomChamp)" class="text-danger">{{ errors.first(nomChamp) }}</span>
        </div>
    </div>

</template>

<script>
import TooltipUtils from '../../utils/TooltipUtils';
import CurrencyUtils from '../../utils/CurrencyUtils';

export default {
  name: 'section-revenu-mask',
  data() {
    return {
      maxLength: 8,
      defaultLength: 8,
    };
  },
  props: {
    submitted: Boolean,
    lblRevenu: String,
    nomChamp: String,
    monnaie: String,
    tooltipTitre: String,
    tooltipContenu: String,
    withValidation: String,
    optionsContenu: Object,
  },
  inject: ['$validator'],
  mixins: [TooltipUtils, CurrencyUtils],
  methods: {
    onInput(input) {
      this.maxLength = this.defaultLength;
      if (/^\d{1,8}$/.test(input.value)) {
        // Remplacer tous les characters qui ne sont pas des chiffres par une string vide
        this.$emit('input', input.value.replace(/\D/g, ''));
      } else if (input.value === '') {
        this.$emit('input', input.value);
      }
    },
    onBlur(input) {
      // Determiner le nombre de ' pour que l'attribute maxLength prenne ça en compte
      const count = (input.value.match(/'/g) || []).length;
      this.maxLength = this.defaultLength + count;
    },
    onFocus() {
      this.maxLength = this.defaultLength;
    },
  },
};
</script>

<style scoped>

</style>
